import {
  COMPANY_LIST_REQUEST,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_FAIL,
  COMPANY_CREATE_REQUEST,
  COMPANY_CREATE_SUCCESS,
  COMPANY_CREATE_FAIL,
  COMPANY_CREATE_RESET,
  COMPANY_DETAILS_REQUEST,
  COMPANY_DETAILS_SUCCESS,
  COMPANY_DETAILS_FAIL,
  COMPANY_UPDATE_REQUEST,
  COMPANY_UPDATE_SUCCESS,
  COMPANY_UPDATE_FAIL,
  COMPANY_UPDATE_RESET,
  COMPANY_DELETE_REQUEST,
  COMPANY_DELETE_SUCCESS,
  COMPANY_DELETE_FAIL,
  COMPANY_TOGGLE_STATUS_REQUEST,
  COMPANY_TOGGLE_STATUS_SUCCESS,
  COMPANY_TOGGLE_STATUS_FAIL,
  COMPANY_STATS_REQUEST,
  COMPANY_STATS_SUCCESS,
  COMPANY_STATS_FAIL
} from '../constants/companyConstants';

export const companyListReducer = (state = { companies: [], currentPage: 1, totalPages: 1, totalRecords: 0 }, action) => {
  switch (action.type) {
    case COMPANY_LIST_REQUEST:
      return { loading: true, companies: [] };
    case COMPANY_LIST_SUCCESS:
      return {
        loading: false,
        companies: action.payload.companies,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
      };
    case COMPANY_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const companyCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case COMPANY_CREATE_REQUEST:
      return { loading: true };
    case COMPANY_CREATE_SUCCESS:
      return { loading: false, success: true, company: action.payload };
    case COMPANY_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case COMPANY_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const companyDetailsReducer = (state = { company: {} }, action) => {
  switch (action.type) {
    case COMPANY_DETAILS_REQUEST:
      return { loading: true, ...state };
    case COMPANY_DETAILS_SUCCESS:
      return { loading: false, company: action.payload };
    case COMPANY_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const companyUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case COMPANY_UPDATE_REQUEST:
      return { loading: true };
    case COMPANY_UPDATE_SUCCESS:
      return { loading: false, success: true, company: action.payload };
    case COMPANY_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case COMPANY_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const companyDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case COMPANY_DELETE_REQUEST:
      return { loading: true };
    case COMPANY_DELETE_SUCCESS:
      return { loading: false, success: true };
    case COMPANY_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const companyToggleStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case COMPANY_TOGGLE_STATUS_REQUEST:
      return { loading: true };
    case COMPANY_TOGGLE_STATUS_SUCCESS:
      return { loading: false, success: true, company: action.payload };
    case COMPANY_TOGGLE_STATUS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const companyStatsReducer = (state = {}, action) => {
  switch (action.type) {
    case COMPANY_STATS_REQUEST:
      return { loading: true };
    case COMPANY_STATS_SUCCESS:
      return { loading: false, stats: action.payload };
    case COMPANY_STATS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
